export const menuItems = [
  {
    id: 1,
    label: "Informasi Pegawai",
    link: "/informasi-pegawai",
    parentId: 1,
  },
  {
    id: 2,
    label: "Pemilihan Kompetensi",
    link: "/pemilihan-kompetensi",
    parentId: 1,
  },
  {
    id: 3,
    label: "Jadwal Asesmen",
    link: "/jadwal-asesmen",
    parentId: 1,
  },
  {
    id: 4,
    label: "History Asesmen",
    link: "/history-asesmen",
    parentId: 1,
  },
];
